export type Role =
	| "PAYDO_ADMIN"
	| "PAYDO_MANAGER"
	| "PAYDO_USER"
	| "CORPORATE_ADMIN"
	| "CORPORATE_OPERATOR"
	| "BANK_CORPORATE_ADMIN"
	| "BANK_CORPORATE_AUTHORIZER"
	| "BANK_AUTHORIZER"
	| "BANK_OPERATOR"
	| "BANK_ADMIN"
	| "BANK_SUPER_ADMIN"
	| "CORPORATE_AUTHORIZER"

interface IRoleAccess {
	[key: string]: Role[]
}

export const RoleAccess: IRoleAccess = {
	PAYDO_ADMIN: [
		"PAYDO_ADMIN",
		"PAYDO_MANAGER",
		"PAYDO_USER",
		"CORPORATE_ADMIN",
		"CORPORATE_OPERATOR",
		"BANK_CORPORATE_ADMIN",
		"BANK_CORPORATE_AUTHORIZER",
		"BANK_AUTHORIZER",
		"BANK_OPERATOR",
		"BANK_ADMIN",
		"BANK_SUPER_ADMIN",
		"CORPORATE_AUTHORIZER",
	],
	PAYDO_MANAGER: [
		"BANK_SUPER_ADMIN",
	],
	PAYDO_USER: [],
	CORPORATE_ADMIN: [
		"CORPORATE_OPERATOR",
	],
	CORPORATE_OPERATOR: [],
	BANK_CORPORATE_ADMIN: [
		"CORPORATE_ADMIN",
		"CORPORATE_AUTHORIZER",
		"CORPORATE_OPERATOR",
	],
	BANK_CORPORATE_AUTHORIZER: [],
	BANK_AUTHORIZER: [],
	BANK_OPERATOR: [],
	BANK_ADMIN: [],
	BANK_SUPER_ADMIN: [
		"BANK_CORPORATE_ADMIN",
		"BANK_CORPORATE_AUTHORIZER",
		"BANK_AUTHORIZER",
		"BANK_OPERATOR",
		"BANK_ADMIN"
	],
	CORPORATE_AUTHORIZER: [],
}
